import React from 'react';
import { Dropdown } from '../../../../../UiKit';
import { Asterisk } from 'lucide-react';

function getDropDownValues(item) {
  if (!item?.items) return {};
  let dropdownValues = {};
  item.items.forEach((element) => {
    dropdownValues = {
      ...dropdownValues,
      [element.key]: element.value,
    };
  });
  return dropdownValues;
}

function FieldRow({
  fields,
  startIndex,
  endIndex,
  fieldWidth,
  inputValues,
  errors,
  onInputChange,
  onFieldFocus,
}) {
  return fields?.map((item, index) => {
    if (!item) return null;
    if (index < startIndex || index > endIndex) return null;
    return (
      <div className={fieldWidth} key={`${item.key}-${index}`}>
        <label className='tw-w-full tw-flex tw-flex-col '>
          <div
            className={`tw-w-full tw-mb-2 tw-text-zinc-800 tw-font-medium tw-text-[1.4rem]`}
          >
            {item.title}
            {!item.optional && (
              <Asterisk size={14} className='tw-text-red-600' />
            )}
          </div>
          {item.type === 'dropdown' ? (
            <div
              css={`
                width: 100%;
                & div {
                  width: 100%;
                  display: flex;
                  align-items: center;
                  height: 5rem;
                }
              `}
            >
              <Dropdown
                dropDownValues={getDropDownValues(item)}
                onSelect={(value) => onInputChange(item.key, value, item.type)}
                dropdownVal={inputValues?.[item.key]}
                placeholder={item.placeholder}
              />
            </div>
          ) : item.type === 'text_area' ? (
            <textarea
              required={!item.optional}
              onChange={(e) =>
                onInputChange(item.key, e.target.value, item.type)
              }
              onFocus={() => onFieldFocus(item.title)}
              placeholder={item.placeholder}
              rows={4}
              className={`tw-appearance-none tw-px-5 tw-py-4 tw-rounded-lg tw-outline-0 tw-resize-y tw-font-[inherit] focus:tw-border-none focus:tw-ring-2
              ${
                errors[`${item.title}`]
                  ? 'tw-ring-red-700 tw-border-red-700'
                  : 'focus:tw-ring-base-green focus:tw-border-base-green tw-border-grey-300'
              }  tw-border tw-border-solid`}
            />
          ) : (
            <input
              required={!item.optional}
              onChange={(e) =>
                onInputChange(item.key, e.target.value, item.type)
              }
              onFocus={() => onFieldFocus(item.title)}
              placeholder={item.placeholder}
              className={`tw-appearance-none tw-px-5 tw-h-20 tw-rounded-lg tw-outline-0  focus:tw-border-none focus:tw-ring-2
              ${
                errors[`${item.title}`]
                  ? 'tw-ring-red-700 tw-border-red-700'
                  : 'focus:tw-ring-base-green focus:tw-border-base-green tw-border-grey-300'
              }  tw-border tw-border-solid`}
            />
          )}
          {errors[`${item.title}`] && (
            <p className='tw-mt-2 tw-text-red-700'>{errors[`${item.title}`]}</p>
          )}
        </label>
      </div>
    );
  });
}

export default FieldRow;
